// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: pure helpers for the tracked-time cell, kept out of the component so
// they can be tested without dragging in the store.

/** "1h30", "1h 30m", "45m", "90" (minutes), "1:30" → milliseconds. */
export function parseDuration(input: string): number | null {
	const text = input.trim().toLowerCase();
	if (!text) return null;
	const clock = /^(\d+):([0-5]\d)$/.exec(text);
	if (clock) return (Number(clock[1]) * 60 + Number(clock[2])) * 60_000;
	const parts = /^(?:(\d+(?:\.\d+)?)\s*h)?\s*(?:(\d+(?:\.\d+)?)\s*m?)?$/.exec(text);
	if (!parts || (parts[1] == null && parts[2] == null)) return null;
	const hours = parts[1] ? Number(parts[1]) : 0;
	const minutes = parts[2] ? Number(parts[2]) : 0;
	const ms = (hours * 60 + minutes) * 60_000;
	return ms > 0 ? ms : null;
}

/** Milliseconds → "45m" / "2h" / "1h 30m"; an em dash when nothing is tracked. */
export function formatTracked(ms: number | null | undefined): string {
	if (!ms || ms <= 0) return '—';
	const totalMinutes = Math.round(ms / 60_000);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	if (hours === 0) return `${minutes}m`;
	return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}
